import {
  BooleanInput,
  Create,
  NumberInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

export const ProductCreate = () => (
  <Create redirect="show">
    <SimpleForm>
      <TextInput source="article" fullWidth label="Артикуль" />
      <TextInput source="name" fullWidth label="Имя" />
      <TextInput source="description" fullWidth label="Описание" />
      <NumberInput source="price" fullWidth label="Цена" />
      <NumberInput source="count" fullWidth label="Количество" />
      <BooleanInput source="is_active" label="Активен" />
    </SimpleForm>
  </Create>
);
